import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { faqs } from '../data/objections';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq-title" className="border-b border-line bg-surface/40" data-id="element-71" data-mp="1bmd7383s4e5l">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8 lg:py-16" data-id="element-72" data-mp="1gk58csqbdcmg">
        <h2 id="faq-title" className="text-center text-lg font-black leading-tight tracking-tight text-ivory sm:text-2xl" data-id="element-73" data-mp="24a91g65vltz7">
          Lo que más nos preguntan
        </h2>

        <ul className="mx-auto mt-6 max-w-2xl divide-y divide-line border-y border-line" data-id="element-74" data-mp="1ujmq4o56zpmb">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.question} data-id="element-75" data-mp="1zgd6lckwsn89" data-mpi={i}>
                <h3 data-id="element-76" data-mp="2n7ilnpj0zbhi">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 py-3.5 text-left transition-colors duration-150 ease-soft hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-77" data-mp="2n70qyxc0h5bp">
                    <span className="text-[13px] font-bold leading-snug tracking-tight text-ivory sm:text-sm" data-id="element-78" data-mp="1el3kor1eiy2x">
                      {faq.question}
                    </span>
                    <PlusIcon aria-hidden="true" className={`h-4 w-4 shrink-0 text-accent transition-transform duration-200 ease-soft ${isOpen ? 'rotate-45' : ''}`} data-id="element-79" data-mp="19t2dhjj3bxjr" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-80" data-mp="1jmj6ilbel8md">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-81" data-mp="1xiobw4rn28qp">
                      <div className="space-y-2 pb-4 pr-6" data-id="element-82" data-mp="1yb7i0oo8jf5v">
                        {faq.answer.map(paragraph => <p key={paragraph} className="text-[12px] leading-snug text-muted" data-id="element-83" data-mp="23aaevlu2af2r">
                            {paragraph}
                          </p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}